export default "__VITE_ASSET__Cr4b_7fW__"